module.exports = __webpack_public_path__ + "img/ruffle front width.b0ee98ee.png";